import React, { FunctionComponent } from "react";

import { partTypeAccessory } from "../../../constants/partTypes";
import { AccessoryPartItem } from "../../../queries/useSearchAccessoriesByVehicle";
import { getDefaultQuantity } from "../../PriceSelect/getDefaultQuantity";
import { usePriceSelectState } from "../../PriceSelect/usePriceSelectState";
import { usePricing } from "../../PriceSelect/usePricing";
import { Image } from "../Common/Image";
import { Actions } from "../Common/LeadForm/Actions";
import { PricingNote } from "../Common/PricingNote";
import { AccessoryDescription } from "./AccessoryDescription";
import { AccessorySpec } from "./AccessorySpec";
import { RelatedParts } from "./RelatedParts";

type AccessoryDetailsProps = {
  part: AccessoryPartItem | null;
};

export const AccessoryDetails: FunctionComponent<AccessoryDetailsProps> = ({
  part,
}) => {
  const [priceEntries, setPriceEntries] = usePriceSelectState([]);
  usePricing({
    defaultQuantity: getDefaultQuantity({
      isStaggered: false,
      orderItem: null,
      part,
    }),
    isStaggered: false,
    onReady: setPriceEntries,
    part,
  });
  return (
    <div className="grid md:grid-cols-3 gap-4">
      <main className="flex flex-col gap-4 md:col-span-2">
        <Image part={part} />
        <RelatedParts
          part={part}
          priceOption={priceEntries[0]?.pricingOption ?? null}
        />
        <AccessorySpec part={part} />
        <AccessoryDescription part={part} />
        <PricingNote partType={partTypeAccessory} />
      </main>
      <aside className="flex flex-col gap-4">
        <Actions
          isStaggered={false}
          part={part}
          priceEntries={priceEntries}
          setPriceEntries={setPriceEntries}
        />
      </aside>
    </div>
  );
};
